<template>
  <div class="wth-wrap">
    <div class="d-flex align-items-center mb-2">
      <h6 class="mb-0 mr-3">Transaction History</h6>
      <button class="btn btn-sm btn-outline-secondary mr-2" @click="load" :disabled="loading || !address">
        {{ loading ? 'Loading…' : '↺ Refresh' }}
      </button>
      <router-link v-if="address" :to="`/${routeChain}/transactions`" class="btn btn-sm btn-outline-secondary ml-auto ml-sm-0">
        Full History →
      </router-link>
    </div>
    <TxTable :txs="txs" :loading="loading" :accent-color="accentColor" :page-size="10" />
  </div>
</template>

<script>
import TxTable from './TxTable.vue';
import { fetchTronTxs, fetchTronTrc20Txs, fetchEthTxs, fetchEthTokenTxs, fetchSolanaTxs, fetchBtcTxs } from '../services/txService';

const CHAIN_ID = { ethereum: 1, bsc: 56, polygon: 137 };
const ROUTE_CHAIN = { bitcoin: 'bitcoin' };

export default {
  name: 'WalletTxHistory',
  components: { TxTable },
  props: {
    chain: { type: String, required: true }, // tron | ethereum | bsc | polygon | solana | bitcoin
    address: { type: String, default: '' },
    accentColor: { type: String, default: '#6366f1' },
  },
  data() {
    return { txs: [], loading: false };
  },
  computed: {
    routeChain() { return ROUTE_CHAIN[this.chain] || this.chain; },
  },
  watch: {
    address(newVal) {
      if (newVal && newVal !== 'N/A') this.load();
      else this.txs = [];
    },
  },
  methods: {
    async load() {
      if (!this.address || this.address === 'N/A') return;
      this.loading = true;
      try {
        let txs = [];
        if (this.chain === 'tron') {
          const [native, trc20] = await Promise.all([
            fetchTronTxs(this.address),
            fetchTronTrc20Txs(this.address),
          ]);
          txs = [...native, ...trc20];
        } else if (this.chain === 'ethereum' || this.chain === 'bsc' || this.chain === 'polygon') {
          const chainId = CHAIN_ID[this.chain];
          const [native, tokens] = await Promise.all([
            fetchEthTxs(this.address, 1, 200, chainId),
            fetchEthTokenTxs(this.address, chainId),
          ]);
          txs = [...native, ...tokens];
        } else if (this.chain === 'solana') {
          const { Connection } = await import('@solana/web3.js');
          const conn = new Connection(`${window.location.origin}/solana-rpc/`);
          txs = await fetchSolanaTxs(this.address, conn, 50);
        } else if (this.chain === 'bitcoin') {
          txs = await fetchBtcTxs(this.address);
        }
        this.txs = txs.sort((a, b) => b.timestamp - a.timestamp);
      } catch (e) {
        console.error('Failed to load transaction history:', e);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.address && this.address !== 'N/A') this.load();
  },
};
</script>

<style scoped>
.wth-wrap { margin-top: 24px; }
</style>
